import React, { useState, useEffect, useContext, useRef } from 'react';
import SessionContext from './SessionContext';
import moment from 'moment';
import { SvgEdit } from '../assets/icons';
import Loading from './Loading';

function Events(props) {
  const sessionContext = useContext(SessionContext);

  const [loading, setLoading] = useState(true)
  const [events, setEvents] = useState([])
  const [minInterval, _] = useState(moment().startOf('day'))
  const [maxInterval, setMaxInterval] = useState(moment().add(1, 'day').startOf('day'))

  const containerToScrollRef = useRef(null)
  const elementToScrollRef = useRef(null)

  const fetchEvents = async () => {
    const client = sessionContext.getGraphqlClient()
    const query = `
      query LoadEvents {
        getSchedule(householdId: "${sessionContext.household.householdId}", scheduleId: "${props.schedule.id}") {
          events {
            id: eventId
            title
            startAt
            endAt
            creator {
              profileId
              given_name
              family_name
              picture
            }
          }
        }
      }
    `

    const request = {
      query,
      variables: null,
      operationName: 'LoadEvents'
    };

    try {
      const resp = await client(request)
      const events = resp.data.getSchedule.events;

      setEvents(events)

      let max = maxInterval
      events.forEach(event => {
        let endInterval = moment(event.endAt)
        endInterval.minutes(0)
        max = moment.max(max, endInterval)
      })
      setMaxInterval(max)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchEvents() }, [sessionContext.isLoading])

  useEffect(() => {
    if(elementToScrollRef.current) {
      containerToScrollRef.current.scrollTop = elementToScrollRef.current.offsetTop - 120;
    }
  })

  const intervals = [...Array((maxInterval - minInterval) / 1000 / 60 / 60)].map((_, i) => minInterval.clone().add(i, 'hours'))

  const currentMoment = moment()
  const isCurrentInterval = interval => currentMoment > interval && currentMoment < interval.clone().add(1, 'hour')

  return (
    <div className="events" ref={containerToScrollRef}>
      { loading && <div className="tile">
        <Loading />
      </div>}
      { !loading && <>
        {intervals.map(interval => {
          //todo: please calculate this in a more intelligent way that does not require scanning the event list on every iteration
          //todo: handle multiple overlapping events
          let eventsInInterval = events.filter(event => (moment(event.startAt) >= interval && moment(event.startAt) < moment(interval).add(1, 'hours')))

          return (
            <div className={`interval tile ${isCurrentInterval(interval) ? 'current' : ''}`} id={interval.unix()} key={interval.unix()} ref={isCurrentInterval(interval) ? elementToScrollRef : null} >
              <label>{interval.format(interval.hours() == 0 ? " M/D LT" : "LT")}</label>
              {eventsInInterval.map(event => {
                // todo: calculate using parent container size and relative position
                const multipler = 70.0 / 60; // container height / minutes
                const top = moment(event.startAt).minutes() * multipler
                const height = moment(event.endAt).diff(moment(event.startAt)) / 1000 / 60 * multipler

                return (
                  <div key={event.id} className="event" style={{ top: top, height: height }}>
                    <img src={event.creator.picture} className="avatar" />
                    <label style={{flexGrow: 1}}>
                      {event.title}
                    </label>
                    <SvgEdit style={{ marginTop: 5, marginRight: 10, cursor: 'pointer' }} onClick={() => props.onEditEntry({ schedule: props.schedule, ...event})} />
                  </div>
                )
              })}
            </div>
          )
        })}
      </>}
    </div>
  );
}

export default Events;
